<template>
  <div class="bg-secondary text-light py-4" v-if="isShown && !isDismissed">
    <div class="close-btn">
      <a @click="isDismissed = true" class="text-hint" title="I don't want updates" href="javascript:void(0)">
        <font-awesome-icon :icon="['far', 'times']" />
      </a>
    </div>
    <div class="single-container px-5">
      <form data-vv-scope="email-form" @submit="submit">
        <div class="row">
          <div class="col">
            <h2 class="text-light font-weight-bold">
              Hey Dr. {{ user.last_name }}, don't miss updates from {{ toDoctorOrPractice }}
            </h2>
            <div class="text-hint font-weight-normal">
              Provide your office's email and receive
              <span class="text-decoration-underline" style="border-bottom: 1px dotted #b1b1b1"
                >notifications for important comments and activity</span
              >
              on your referrals
            </div>
            <div class="d-flex">
              <div class="form-group mt-3 single-input-container">
                <label class="d-none">Office email</label>
                <div class="input-group input-group-lg">
                  <input
                    v-model="email"
                    type="text"
                    class="form-control form-control-lg"
                    name="email"
                    data-vv-as="office email"
                    v-validate
                    required
                    placeholder="frontdesk@office.com"
                  />
                  <div class="input-group-append">
                    <button class="btn-primary btn btn-lg">Keep me updated</button>
                  </div>
                </div>
                <span class="invalid-feedback d-block">{{ errors.first('email', 'email-form') }}</span>
              </div>
              <div class="align-items-center justify-content-center d-flex ml-3">
                <a href="javascript:void(0);" class="text-muted" @click="isDismissed = true"
                  >No, I don't want updates</a
                >
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: ['referral'],
  data() {
    return {
      email: '',
      isDismissed: false,
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    practice() {
      return this.user?.practice
    },
    isShown() {
      return this.practice && !this.practice.email
    },
    doctorFull() {
      return this.doctorFirst + ' ' + this.doctorLast
    },
    toDoctorOrPractice() {
      const doc = this.referral?.doctor
      return doc === 'Any (First Available)' ? this.referral.to_practice.name : 'Dr. ' + doc
    },
  },
  methods: {
    async submit(e) {
      e.preventDefault()
      if (await this.$validator.validate()) {
        await this.$store.dispatch('practices/save', { ...this.practice, email: this.email })
        this.$router.push('/')
      }
    },
  },
}
</script>

<style scoped>
.single-container {
  max-width: 1080px;
  margin: 0 auto;
}
.single-input-container {
  max-width: 480px;
}
.close-btn {
  position: absolute;
  right: 1.5rem;
  top: 1rem;
  font-size: 1.1rem;
}
</style>